import React from 'react';

import { Column } from '@solent-university/solent-icons';

import {
    Wrapper,
    WidgetContainer,
    CardSlot,
    CompareButton,
    CardWrapper,
    InteractionContainer,
    RemoveTextButton
} from './Widget.styled';

import Card, { CourseCompareCardProps } from 'Modules/CourseCompare/subcomponents/Card';

export interface Props {
    courses?: (CourseCompareCardProps | undefined)[];
    onCompare: () => void;
    className?: string;
    clearCourses: () => void;
}

const Widget: React.FC<Props> = ({ courses, onCompare, className, clearCourses }) => {
    /*nullish coalescing operator - return 0 if courses.length is undefined/null & evaluate*/
    const isActive = (courses?.length ?? 0) > 0;

    return (
        <Wrapper className={className} aria-hidden={!isActive} $isActive={isActive}>
            <WidgetContainer role="complementary" aria-label="Course comparison widget">
                {[...Array(3)].map((_, index) => {
                    const course: CourseCompareCardProps | undefined = courses?.[index];
                    return (
                        <CardSlot key={course?.id || `card-slot-${index}`} isEmpty={!course}>
                            {courses && courses.length >= 1 && course && (
                                <CardWrapper>
                                    <Card
                                        id={course.id}
                                        degreeType={course.degreeType}
                                        course={course.course}
                                        image={course.image}
                                        closeButtonFnc={course.closeButtonFnc}
                                    />
                                </CardWrapper>
                            )}
                        </CardSlot>
                    );
                })}
                <InteractionContainer>
                    <CompareButton
                        onClick={onCompare}
                        disabled={courses && courses.length < 2}
                        $disabled={courses && courses.length < 2}
                        $animate={courses && courses.length >= 2}
                        aria-label="Click for more in depth comparison of selected courses"
                    >
                        Compare {courses && courses.length} of 3 <Column />
                    </CompareButton>
                    <RemoveTextButton onClick={clearCourses} aria-label="Remove all courses">
                        Remove all courses
                    </RemoveTextButton>
                </InteractionContainer>
            </WidgetContainer>
        </Wrapper>
    );
};

export default Widget;
